<template lang="pug">
#filtro-rastreabilidade.view-container
    .container-filtros
        .filtros-base
            .pesquisa-inteligente__container
                .pesquisa-inteligente__barra-pesquisa
                    i.el-icon-search
                    input(
                        v-model='pesquisa.textoBusca',
                        type='text',
                        :placeholder='textoPlaceHolder',
                        autocomplete='off',
                        @keyup.enter='filtrar',
                    )

            .filtros-avancados
                el-popover(placement='bottom', width='500', trigger='click')
                    BaseButton.button-outline(
                        icon='lyra-icon lyra-filtro',
                        name='filtro',
                        plain,
                        slot='reference'
                    ) Filtros Avançados

                    .filtro-avancado
                        .filtro-header
                            span.titulo-filtro Filtros avançados
                            span.aplicar-filtro(@click='filtrar()') Aplicar Filtro

                        .filtro-data
                                el-date-picker(
                                    v-model="filtroData",
                                    placement='bottom-start',
                                    type="daterange",
                                    placeholder='Data',
                                    start-placeholder="Data de início",
                                    end-placeholder="Data do fim",
                                    format='dd/MM/yyyy'
                                )

                        .filtro-itens
                            el-collapse(style='border: none' v-model='activeNames' @change='handleChange')
                                el-collapse-item.collapse-titulo(title="Fazendas" name="1")
                                    el-checkbox-group(v-model="checkListFazendas")
                                        el-checkbox.checkbox-item(label="Fazendas Bonsucro")

</template>

<script>
import { ref } from 'vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'FiltroAvancadoRastreabilidade',
    components: {
        BaseButton
    },
    props: {
        textoPlaceHolder: {
            type: String,
            default: () => ''
        }
    },

    data() {
        return {
            activeNames: ['1'],
            checkListFazendas: ref([]),
            filtroData: [],
            pesquisa: {
                textoBusca: '',
                dataInicioPesquisa: '',
                dataFimPesquisa: '',
                fazendasCertificadas: ''
            }
        };
    },

    methods: {
        handleChange (val) {
            this.activeNames = [...this.activeNames, val];
        },

        filtrar() {
            if (!this.filtroData) {
                this.filtroData = [];
            }
            this.pesquisa.dataInicioPesquisa = this.filtroData[0] ? this.filtroData[0].toLocaleDateString('pt-BR') : '';
            this.pesquisa.dataFimPesquisa = this.filtroData[1] ? this.filtroData[1].toLocaleDateString('pt-BR') : '';
            this.pesquisa.fazendasCertificadas = this.checkListFazendas.length > 0;
            
            this.$emit('atualizar-filtro-avancado', this.pesquisa);
        }
    }
};
</script>

<style lang="scss" scoped>

.container-filtros {
    width: 100%;
}

.filtros-base {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}

.filtro-avancado {
    width: 100%;
    display: flex;
    flex-direction: column;
}
.filtro-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 20px;
}

.titulo-filtro{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 14px;
    color: #00413C;
}
.aplicar-filtro{
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 14px;
    text-decoration-line: underline;
    color: #036BE4;
    &:hover {
        cursor: pointer;
    }
}

.filtro-itens {
    width: 100%;
    overflow: hidden;
    border-radius: 4px;
}

.collapse-titulo {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    color: #3B3B3B;
}

.checkbox-item {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: #3B3B3B;
}

.card-filtro-avancado {
    position: relative;
    width: 599px;
    height: 356px;

    background: #FFFFFF;
    box-shadow: 0px 4px 35px rgba(0, 0, 0, 0.12);
    border-radius: 5px;

    .filtro-data{

        box-sizing: border-box;
        width: 18%;
        height: 41px;

        background: #FFFFFF;
        border: 1px solid #C1C1C1;
        border-radius: 5px;

        flex: none;
        order: 0;
        flex-grow: 0;
    }

    .fazendas{

        width: 60px;
        height: 14px;

        font-family: 'Roboto';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;

        color: #3B3B3B;

        flex: none;
        order: 1;
        flex-grow: 0;
    }

    .fazendas-tipos{
        width: 123px;
        height: 14px;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        color: #3B3B3B;

        flex: none;
        order: 1;
        flex-grow: 0;
    }

}

.filtros {
    display: flex;
    justify-content: space-between;
}

.pesquisa-inteligente__container {
    width: 100%;
    height: 42px;
    border-radius: 5px;
    background: var(--white);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    position: relative;
    margin-right: 10px;
}

.pesquisa-inteligente__barra-pesquisa {
    height: 100%;
    display: flex;
    justify-content: center;

    i.el-icon-search {
        color: var(--primary);
        font-size: 25px;
        font-weight: bold;
        display: flex;
        align-items: center;
        margin: 0 8px;
    }

    input {
        width: 100%;
        height: 100%;
        border: none;
        outline: none;
        border-radius: 5px;
        color: var(--primary);
    }
}
</style>
